var exports = {
  "CT": "DiscoverySkeleton.module__navList___WVZWMl",
  "pc": "DiscoverySkeleton.module__navItem___WVZWMl",
  "HW": "DiscoverySkeleton.module__navItemActive___WVZWMl",
  "hk": "DiscoverySkeleton.module__navItemLabel___WVZWMl",
  "kL": "DiscoverySkeleton.module__container___WVZWMl",
  "v_": "DiscoverySkeleton.module__navbar___WVZWMl",
  "$L": "DiscoverySkeleton.module__categoryTabs___WVZWMl",
  "VJ": "DiscoverySkeleton.module__navbarSearch___WVZWMl",
  "Gm": "DiscoverySkeleton.module__scrollBody___WVZWMl",
  "Qs": "DiscoverySkeleton.module__content___WVZWMl",
  "Vg": "DiscoverySkeleton.module__grid___WVZWMl",
  "Nr": "DiscoverySkeleton.module__card___WVZWMl",
  "zl": "DiscoverySkeleton.module__cardBanner___WVZWMl",
  "Ie": "DiscoverySkeleton.module__cardIcon___WVZWMl",
  "zI": "DiscoverySkeleton.module__cardBody___WVZWMl",
  "JJ": "DiscoverySkeleton.module__cardTitle___WVZWMl",
  "L_": "DiscoverySkeleton.module__cardDescription___WVZWMl",
  "UX": "DiscoverySkeleton.module__cardFooter___WVZWMl",
  "Kd": "DiscoverySkeleton.module__cardStats___WVZWMl",
  "Ne": "DiscoverySkeleton.module__cardStat___WVZWMl",
};

module.exports = exports;
